import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useMemo } from "react";
export var ProductTileViewImpressionUpperThresholdContext = /*#__PURE__*/ createContext({
    heightFromTop: 0,
    setHeightFromTop: function() {
        return 0;
    }
});
ProductTileViewImpressionUpperThresholdContext.displayName = "ProductTileViewImpressionUpperThresholdContext";
export var ProductTileViewImpressionUpperThresholdProvider = function(param) {
    var children = param.children, setHeightFromTop = param.setHeightFromTop, heightFromTop = param.heightFromTop;
    var value = useMemo(function() {
        return {
            heightFromTop: heightFromTop,
            setHeightFromTop: setHeightFromTop
        };
    }, [
        heightFromTop,
        setHeightFromTop
    ]);
    return /*#__PURE__*/ _jsx(ProductTileViewImpressionUpperThresholdContext.Provider, {
        value: value,
        children: children
    });
};
